import { render, staticRenderFns } from "./AdditionalQuestions.vue?vue&type=template&id=33ff08a6&scoped=true"
import script from "./AdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./AdditionalQuestions.vue?vue&type=script&lang=js"
import style0 from "./AdditionalQuestions.vue?vue&type=style&index=0&id=33ff08a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff08a6",
  null
  
)

export default component.exports